import { z } from 'zod'

export const contentSearchSchema = z.object({
  page: z.coerce.number().int().min(1).catch(1).default(1),
  q: z.string().catch('').default(''),
  docId: z.coerce.number().int().min(1).optional().catch(undefined)
})
